import { useLocation } from "react-router";
import { parseQueryParams } from "core/utils/urls";

export function useQueryParams() {
  const location = useLocation();
  const queryParams = parseQueryParams(location.search || {});
  return queryParams;
}
